'use strict';
var parent = require('../../stable/math');
require('../../modules/es.array.iterator');
require('../../modules/esnext.math.f16round');
require('../../modules/esnext.math.sum-precise');

module.exports = parent;
